import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const tiles = [
  { id: '01', value: '200%', label: 'Open Rate Boost', sub: 'Average lift across rebuilt nurture flows.' },
  { id: '02', value: '10–100×', label: 'Revenue Growth', sub: 'From newsletter monetization + segmented campaigns.' },
  { id: '03', value: '2,000+', label: 'Lead-Magnet Downloads', sub: 'Single landing page + Kit.com form.' },
];

const StatTiles = () => {
  return (
    <section className="container-x section pt-0" data-testid="stat-tiles">
      <div className="grid md:grid-cols-3 gap-5">
        {tiles.map((t) => (
          <div
            key={t.id}
            data-testid={`stat-tile-${t.id}`}
            className="card-cream p-7 md:p-8 flex flex-col"
          >
            <div className="flex items-center justify-between">
              <span className="text-[11px] uppercase tracking-widest text-muted-warm font-semibold">{t.id}</span>
              <ArrowUpRight className="w-4 h-4 text-[var(--gh-orange)]" />
            </div>
            <p className="font-display text-5xl md:text-6xl font-extrabold text-ink mt-6 leading-none tracking-tighter">
              {t.value}
            </p>
            <p className="mt-4 text-base font-semibold text-ink">{t.label}</p>
            <p className="mt-1 text-sm text-muted-warm">{t.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatTiles;
